import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/',
    component: () => import('./pages/index'),
  },
  {
    path: '/index',
    component: () => import('./pages/index'),
  },
  {
    path: '/brand_info',
    component: () => import('./pages/brand_info'),
  },
  {
    path: '/brand_story',
    component: () => import('./pages/brand_story'),
  },
  {
    path: '/store',
    component: () => import('./pages/store'),
  },
  {
    path: '/product',
    component: () => import('./pages/product'),
  },
  {
    path: '/contact',
    component: () => import('./pages/contact'),
  },

];


// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'history', routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};